<template>
  <div
    class="flex-inside"
    :class="{hide: this.screenWidth < 979 && this.$route.fullPath.includes('tab2') }"
  >
    <CreateTemplate
      v-if="this.displayCreateTemplate == true"
      v-on:new-template-added="addTemplateLocally($event)"
      v-on:close-create-template="toggleDisplayCreateTemplate"
      :propertyid="currentIssue.propertyid"
      :issueid="currentIssue.issueid"
    ></CreateTemplate>

    <EditTemplate
      v-if="this.displayEditTemplate == true"
      v-on:template-edited="updateTemplateLocally($event)"
      v-on:close-edit-template="toggleDisplayEditTemplate"
      :template="selectedTemplate"
    ></EditTemplate>

    <DeleteTemplate
      v-if="this.displayDeleteTemplate == true"
      v-on:template-deleted="deleteTemplateLocally($event)"
      v-on:close-delete-template="toggleDisplayDeleteTemplate"
      :template="selectedTemplate"
    ></DeleteTemplate>

    <RecurringIssueHistory
      :currentMaintenanceHistory="this.currentMaintenanceHistory"
      v-if="this.displayRecurringHistory == true"
      v-on:close-recurring-history="toggleRecurringHistory()"
    ></RecurringIssueHistory>

    <div class="note-pad">
      <p
        v-if="Object.keys(this.currentIssue).length === 0"
        id="no-issue"
      >Please select a Work Order to view the comments.</p>

      <div v-if="Object.keys(this.currentIssue).length !== 0">
        <div
          v-if="(this.currentIssue.recurring == false && currentIssue.status == true)
                    || (this.currentIssue.recurring == true && currentIssue.cancompletealready == true)"
          style="text-align:right; display: inline-block"
        >
          <el-button
            class="tst-complete-issue-button"
            type="primary"
            @click.native="closeIssue()"
            style="margin: 17px 12px 5px;"
          >Complete Work Order</el-button>
        </div>

        <div
          v-if="this.currentIssue.recurring == false &&
                    this.currentIssue.status == false &&
                    this.currentIssue.permissions.canreopenissue == true"
        >
          <el-button style="margin: 17px 12px 5px;" @click.native="reopenIssue()">Reopen Work Order</el-button>
        </div>
        <div style="display: flex;">
          <div class="title-parent">
            <p class="title">
              {{currentIssue.issuetitle}}
              <span
                v-if="currentIssue.issuetitle == null || currentIssue.issuetitle == ''"
                id="no-title"
              >No title</span>
            </p>
            <p class="recurring-detail" v-if="currentIssue.recurring == true">
              Recurring every {{currentIssue.recurringdays[0]}} days.
              <a
                class="a-link-style"
                @click="toggleRecurringHistory()"
              >
                View history
                <span
                  v-if="currentMaintenanceHistory.length > 0"
                >({{currentMaintenanceHistory.length}})</span>
              </a>
            </p>
          </div>
        </div>

        <div>
          <p class="p-header description">Description:</p>
          <p class="description p-inner">
            {{currentIssue.description}}
            <span
              v-if="currentIssue.description == null || currentIssue.description ==''"
            >No description</span>
          </p>
        </div>

        <div>
          <p class="p-header">User opened:</p>
          <p class="p-inner">
            <el-avatar
              style="vertical-align: middle; width:25px; height:25px;"
              :src="currentIssue.useropenedpicurl"
            ></el-avatar>
            {{currentIssue.useropenedname}}
          </p>
        </div>

        <div>
          <p class="p-header">Assignee:</p>

          <p class="p-inner" v-if="this.choosingNewAssignee == false">
            <el-avatar
              v-if="currentIssue.userassignedpicurl != null"
              style="vertical-align: middle; width:25px; height:25px;"
              :src="currentIssue.userassignedpicurl"
            ></el-avatar>
            <el-avatar
              size="small"
              v-if="currentIssue.userassignedpicurl == null"
              style="vertical-align: middle; "
              icon="el-icon-user-solid"
            ></el-avatar>
            {{currentIssue.userassignedname}}
            <span
              v-if="currentIssue.userassignedname == null"
            >No assignee</span>
          </p>

          <a
            v-if="this.currentIssue.permissions.canedit == true &&
                      this.choosingNewAssignee == false"
            class="a-link-style"
            @click="enableToChangeAssignee()"
          >change assignee</a>

          <AssignToIssue
            v-if="this.choosingNewAssignee == true"
            style="display: inline-block"
            v-on:contact-assigned="assignContact($event)"
            :selectedUserId="this.currentIssue.userassigned"
            :propertyid="this.propertyid"
            :machineid="this.issueheaders.machineid"
          />

          <el-button
            style="margin-left: 10px"
            v-if="this.choosingNewAssignee == true"
            @click="choosingNewAssignee = false"
          >Cancel</el-button>
        </div>

        <div v-if="currentIssue.status == true">
          <p class="p-header">Due date:</p>

          <p
            v-if="this.choosingNewDueDate == false"
            :class="{ 'due-date-red': currentIssue.overdue }"
            class="p-inner"
          >
            <i
              class="far fa-lg fa-calendar-alt"
              style=" vertical-align: middle; width:25px; height:25px;"
            ></i>

            <span v-if="currentIssue.duedate != null">{{currentIssue.duedate}}</span>

            <span
              id="no-due-date"
              v-if="currentIssue.duedate == null
                      "
            >No due date</span>
          </p>
          <a
            v-if="this.currentIssue.recurring == false &&
                     this.currentIssue.permissions.canedit == true && 
                      this.choosingNewDueDate == false"
            class="a-link-style"
            @click="enableToChangeDueDate()"
          >edit due date</a>

          <el-date-picker
            v-if="this.choosingNewDueDate == true"
            v-model="newChosenDate"
            placeholder="Pick a day"
            @change="changeDueDate"
          ></el-date-picker>

          <el-button
            style="margin-left: 10px"
            v-if="this.choosingNewDueDate == true"
            @click="choosingNewDueDate = false"
          >Cancel</el-button>
        </div>

        <div v-if="currentIssue.status == false">
          <p class="p-header">Closed date:</p>
          <p class="p-inner">{{currentIssue.closeddate}}</p>
        </div>

        <div>
          <p class="p-header">Priority level:</p>
          <p
            class="p-inner"
            v-if="this.choosingNewPriority == false"
          >{{currentIssue.issuepriorityname}}</p>

          <a
            class="a-link-style"
            v-if="this.currentIssue.permissions.canedit == true &&
                        this.choosingNewPriority == false"
            @click="enableToChangePriority"
          >edit priority level</a>

          <el-dropdown v-if="this.choosingNewPriority" @command="selectPriority" trigger="click">
            <el-button type="primary">
              {{currentIssue.issuepriorityname}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="priority in this.priorityList"
                :key="priority.issuepriorityid"
                :command="priority"
              >{{priority.issuepriorityname}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            style="margin-left: 10px"
            v-if="this.choosingNewPriority == true"
            @click="choosingNewPriority = false"
          >Cancel</el-button>
        </div>
        <div>
          <p class="p-header">Property:</p>
          <p class="p-inner">{{currentIssue.propertyname}}</p>
        </div>

        <div v-if="currentIssue.machinename != null">
          <p class="p-header">Asset:</p>
          <p class="p-inner">{{currentIssue.machinename}}</p>
        </div>

        <div>
          <p class="p-header">Template:</p>
          <p class="p-inner">
            <el-dropdown trigger="click" v-if="this.templates.length > 0">
              <el-button style="min-width:80px;" type="primary">{{selectedTemplate.templatetitle}}</el-button>

              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="template in this.templates"
                  :key="template.texteditertemplateid"
                >
                  <el-button
                    type="text"
                    style="color:unset; min-width:40px;"
                    @click="selectTemplate(template)"
                  >{{template.templatetitle}}</el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <a
              v-if="this.templates.length > 0"
              class="a-link-style"
              @click="toggleDisplayEditTemplate()"
            >Edit</a>

            <a
              v-if="this.templates.length > 0"
              class="a-link-style"
              @click="toggleDisplayDeleteTemplate()"
            >Delete</a>

            <a @click="toggleDisplayCreateTemplate" class="a-link-style">Create new template</a>
          </p>
        </div>
        <div class="ckeditor-parent">
          <ckeditor
            v-if="this.templates.length > 0"
            :editor="editor"
            v-model="selectedTemplate.templatetext"
            :config="editorConfig"
            @input="updateTemplateInDatabase"
            @ready="disableEditorExceptChecklist"
            class="ckeditor"
          ></ckeditor>
        </div>

        <div class="opened-details">
          <p
            class="open-date p-inner"
          >Opened at {{currentIssue.openeddate | moment("timezone", $timeZone, "MMM DD YYYY hh:mm A")}}</p>
        </div>

        <div v-if="this.loading == true" class="loader"></div>
        <div class="log-parent">
          <LogsForIssues
            v-on:messages-read="markMessagesRead()"
            :loglist="this.logsofcurrentlyselectedissue"
            :logheaders="this.logheadersofcurrentlyselectedissue"
            :issueid="this.currentIssue.issueid"
            :propertyid="this.propertyid"
            :loading="this.loading"
            :unreadMessages="this.currentIssue.unreadmessagescount"
          />
        </div>
      </div>
      <div id="bottom"></div>
    </div>

    <div>
      <CreateLogFormForIssues
        v-if="this.logheadersofcurrentlyselectedissue.cancreatenote == true &&
                  Object.keys(this.currentIssue).length > 0"
        v-on:add-log-locally="addLogLocally($event)"
        v-on:local-log-return-data="updateLocalLogData($event)"
        :propertyid="this.propertyid"
        :currentissueid="this.currentIssue.issueid"
        :key="createFormKey"
      />
    </div>
    <div class="editor2"></div>
  </div>
</template>

<script>
import CreateLogFormForIssues from "@/components/issues/CreateLogFormForIssues.vue";
import LogsForIssues from "@/components/issues/LogsForIssues.vue";
import EventService from "@/services/EventService.js";
import AssignToIssue from "@/components/issues/AssignToIssue.vue";
import RecurringIssueHistory from "@/components/issues/RecurringIssueHistory.vue";
import moment from "moment";
import CreateTemplate from "@/components/templates/CreateTemplate.vue";
import EditTemplate from "@/components/templates/EditTemplate.vue";
import DeleteTemplate from "@/components/templates/DeleteTemplate.vue";
import ClassicEditor from "@/CKeditorCustom/ckeditor5/build/ckeditor.js";

import CKEditor from "@ckeditor/ckeditor5-vue2";
export default {
  props: {
    currentIssue: Object,
    issueheaders: Object,
    propertyid: String,
    priorityList: Array
  },
  components: {
    CreateLogFormForIssues,
    LogsForIssues,
    AssignToIssue,
    RecurringIssueHistory,
    CreateTemplate,
    EditTemplate,
    DeleteTemplate,
    ckeditor: CKEditor.component
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      templates: [],
      selectedTemplate: {},
      displayCreateTemplate: false,
      displayEditTemplate: false,
      displayDeleteTemplate: false,
      choosingNewDueDate: false,
      choosingNewAssignee: false,
      choosingNewPriority: false,
      loading: false,
      currentMaintenanceHistory: [],
      logsofcurrentlyselectedissue: [],
      logheadersofcurrentlyselectedissue: {},
      createFormKey: 10,
      newChosenDate: null,
      scrollDown: false,
      displayRecurringHistory: false,
      // this takes the issue id from the url of the current page
      issueid: this.$router.currentRoute.hash.replace("#issue-", "")
    };
  },
  watch: {
    currentIssue: {
      handler: function(newVal, oldVal) {
        this.$emit("update:currentIssue", newVal);

        if (newVal != undefined) {
          this.getTemplates();
        }
      },
      deep: true
    }
  },
  mounted() {
    // if current issue is not a empty object - meaning an issue is selected - then get relavant data
    // but if on a "mobile device AND not inside an issue" don't try to call API, issue id is undefined
    if (
      (console.log("hello world", this.currentIssue),
      Object.keys(this.currentIssue).length > 0 &&
        (this.screenWidth > 979 || this.$route.fullPath.includes("issue-")))
    ) {
      this.getLogsOfIssue(this.issueid);

      if (this.currentIssue.maintenanceid != null) {
        this.getMaintenanceHistory(this.currentIssue.maintenanceid);
      }

      this.currentIssue.closeddate = moment
        .parseZone(this.currentIssue.closeddate)
        .format("MMM DD YYYY");

      // if it's undefined it gets called in watch: {}
      if (this.currentIssue != undefined) {
        this.getTemplates();
      }
    }
  },
  methods: {
    getTemplates() {
      var issueid = this.currentIssue.issueid;

      EventService.getTemplatesForIssue(issueid)
        .then(response => {
          this.templates = response.data.TextEditerTemplateGetModel;

          if (this.templates.length > 0) {
            this.selectTemplate(this.templates[0]);
          }
        })
        .catch(error => {
          console.error("There was an error!", error);
        });
    },
    selectTemplate(template) {
      template.templatetext = unescape(template.templatetext);
      this.selectedTemplate = template;

      // var checkboxes = document.querySelectorAll('.todo-list__label > input[type=checkbox]');
      // if(checkboxes.length > 0)
      // {
      //     for(var ii = 0; ii < checkboxes.length; ii++)
      //     {

      //         checkboxes[ii].addEventListener('click', function() {

      //             if(this.checked)
      //             {
      //             this.setAttribute("checked", this.checked);
      //             }
      //             else
      //             {
      //             this.removeAttribute("checked");
      //             }
      //         })
      //     }
      // }
    },
    addTemplateLocally($event) {
      this.templates.push($event);

      var indexOfCreatedTemplate = this.templates.indexOf($event);

      var templateToSelect = this.templates[indexOfCreatedTemplate];

      this.selectTemplate(templateToSelect);
    },
    updateTemplateLocally($event) {
      // $event[1].templatetext =  unescape($event[1].templatetext);
      var indexOfEditedTemplate = this.templates.indexOf($event[0]);

      this.templates[indexOfEditedTemplate].templatetitle =
        $event[1].templatetitle;

      this.templates[indexOfEditedTemplate].templatetext =
        $event[1].templatetext;
    },
    deleteTemplateLocally($event) {
      this.$delete(this.templates, this.templates.indexOf($event));
      this.selectTemplate(this.templates[0]);
    },
    toggleDisplayCreateTemplate() {
      this.displayCreateTemplate = !this.displayCreateTemplate;
    },
    toggleDisplayEditTemplate() {
      this.displayEditTemplate = !this.displayEditTemplate;
    },
    toggleDisplayDeleteTemplate() {
      this.displayDeleteTemplate = !this.displayDeleteTemplate;
    },
    updateTemplateInDatabase() {
      var editedContent = {
        templatetext: escape(this.selectedTemplate.templatetext),
        templatetitle: this.selectedTemplate.templatetitle
      };

      EventService.updateTemplate(
        this.selectedTemplate.texteditertemplateid,
        editedContent
      ).catch(error => {
        console.log(error);
      });
    },
    disableEditorExceptChecklist(editor) {
      var i = 0;
      for (const command of editor.commands.commands()) {
        // if ( JSON.stringify(command.constructor).includes("$P") ) {
        //     // Do not disable commands from the comments plugin.
        //     continue;
        // }

        if (i == 47) {
          continue;
        }

        // console.log(command.constructor(ClassicEditor))
        //  console.log(JSON.stringify(command))

        // Force them to be disabled.
        command.on(
          "change:isEnabled",
          evt => {
            command.isEnabled = false;
            evt.stop();
          },
          { priority: "highest" }
        );

        command.isEnabled = false;
        i++;
      }
    },
    getLogsOfIssue(issueid) {
      this.loading = true;

      EventService.getLogsofIssue(issueid).then(response => {
        this.loading = false;
        this.scrollDown = false;
        this.logsofcurrentlyselectedissue = response.data.loglists;

        this.logheadersofcurrentlyselectedissue = response.data;

        var x = window.matchMedia("(max-width: 979px)");
        if (x.matches) {
          this.onMobileIssueLogPage = true;
          this.changeBackButtonForMobile();
        }
      });

      this.createFormKey++;
    },
    getMaintenanceHistory(maintenanceid) {
      EventService.getRecurringIssueHistory(maintenanceid).then(response => {
        response.data.maintenancehistory.forEach(pastMaintenance => {
          pastMaintenance.scheduleddate = moment
            .parseZone(pastMaintenance.scheduleddate)
            .format("MMM DD YYYY");
          pastMaintenance.completeddate = moment
            .parseZone(pastMaintenance.completeddate)
            .format("MMM DD YYYY");
        });

        this.currentMaintenanceHistory = response.data.maintenancehistory;
      });
    },
    addLogLocally($event) {
      this.scrollDown = true;
      this.logsofcurrentlyselectedissue.push($event);
    },
    markMessagesRead() {
      this.currentIssue.unreadmessagescount = 0;
    },
    updateLocalLogData($event) {
      this.$set(
        this.logsofcurrentlyselectedissue,
        this.logsofcurrentlyselectedissue.indexOf($event[0]),
        $event[1]
      );
    },
    closeIssue() {
      EventService.closeIssue(this.currentIssue.issueid)
        .then(response => {
          if (this.currentIssue.recurring == false) {
            this.currentIssue.closeddate = moment
              .parseZone(response.data)
              .format("MMM DD YYYY");

            this.currentIssue.status = false;

            this.currentIssue.overdue = false;
          } else {
            this.currentIssue.duedate = moment
              .parseZone(response.data)
              .format("MMM DD YYYY");
            this.currentIssue.cancompletealready = false;
            this.currentIssue.overdue = false;

            // this.currentIssue.duedate = this.getDueDate(this.currentIssue.recurringdays[0]);

            this.getMaintenanceHistory(this.currentIssue.maintenanceid);
          }
          this.$store.dispatch("addNotification", {
            type: "success",
            Message: "Work Order Completed"
          });

          //this.$set(this.issuelist, this.issuelist.indexOf(this.currentIssue), this.currentIssue);
        })
        .catch(error => {
          console.log(error);
        });
    },
    reopenIssue() {
      EventService.reopenIssue(this.currentIssue.issueid).then(response => {
        this.currentIssue.status = true;

        this.$store.dispatch("addNotification", {
          type: "success",
          Message: "Work Order Reopened"
        });
      });
    },
    toggleRecurringHistory() {
      this.displayRecurringHistory = !this.displayRecurringHistory;
    },
    enableToChangeAssignee() {
      this.choosingNewAssignee = true;
    },
    assignContact($event) {
      this.choosingNewAssignee = false;

      if ($event == "Unassigned") {
        EventService.unassignContact(this.currentIssue.issueid)
          .then(() => {
            this.currentIssue.userassigned = null;
            this.currentIssue.userassignedname = null;
            this.currentIssue.userassignedpicurl = null;

            this.$store.dispatch("addNotification", {
              type: "success",
              Message: "Unassigned work order"
            });
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        EventService.assignContact(this.currentIssue.issueid, $event)
          .then(() => {
            EventService.getUserInfo($event).then(response => {
              var fullName =
                response.data.firstname + " " + response.data.lastname;
              this.currentIssue.userassignedname = fullName;
              this.currentIssue.userassignedpicurl = response.data.imageurl;
              this.currentIssue.userassigned = response.data.userid;
            });

            this.$store.dispatch("addNotification", {
              type: "success",
              Message: "Assignee changed"
            });
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    enableToChangeDueDate() {
      this.choosingNewDueDate = true;
    },
    changeDueDate() {
      var chosenDateToCompare = new Date(moment(this.newChosenDate));

      if (chosenDateToCompare < new Date().setHours(0, 0, 0, 0)) {
        this.$store.dispatch("addNotification", {
          type: "failure",
          Message: "Due date earlier than today"
        });

        this.newChosenDate = null;

        this.choosingNewDueDate = false;

        return;
      }

      EventService.changeIssueDueDate(
        this.currentIssue.issueid,
        moment(this.newChosenDate).format()
      )
        .then(() => {
          this.$store.dispatch("addNotification", {
            type: "success",
            Message: "Due date changed"
          });
        })
        .catch(error => {
          console.log(error);
        });

      this.currentIssue.duedate = moment
        .parseZone(this.newChosenDate)
        .format("MMM DD YYYY");

      this.choosingNewDueDate = false;

      this.currentIssue.overdue = false;
    },
    enableToChangePriority() {
      this.choosingNewPriority = true;
    },
    selectPriority(priority) {
      this.choosingNewPriority = false;

      EventService.changeIssuePriority(
        this.currentIssue.issueid,
        priority.issuepriorityid
      )
        .then(response => {
          this.currentIssue.issuepriorityname = priority.issuepriorityname;
          this.currentIssue.issuepriorityid = priority.issuepriorityid;

          this.$store.dispatch("addNotification", {
            type: "success",
            Message: "priority level updated"
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeBackButtonForMobile() {
      this.$root.$emit("logs-of-issue-on-mobile");
    },
    scrollToBottom() {
      var elmnt = document.getElementById("bottom");

      elmnt.scrollIntoView();
    }
  },
  updated() {
    if (this.scrollDown == true) {
      this.scrollToBottom();
      this.scrollDown = false;
    }
  },
  computed: {
    screenWidth: function() {
      return document.documentElement.clientWidth;
    }
  }
};
</script>

<style scoped>
.note-pad {
  overflow-y: scroll;
  font-size: 21px;
  flex-grow: 1;
}

.flex-inside {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
}

.title-parent {
  margin: 1vh;
  display: inline-block;
  flex-grow: 1;
}

.title {
  text-align: center;
  font-size: 28px;
  margin: 0px;
  color: rgb(89, 89, 89);
}

a {
  padding: 6px 8px 6px 12px;
  text-decoration: none;
  font-size: 14px;
  color: rgb(89, 89, 89);
  display: inline-block;
  cursor: pointer;
}

.a-link-style {
  text-decoration: underline;
  color: #02746e;
}

.a-link-style:hover {
  background-color: unset;
  color: unset;
}
.hide {
  display: none;
}

#no-issue {
  font-weight: bold;
  font-style: italic;
  text-align: center;
  display: block;
}

#no-title {
  font-size: 30px;
}

.p-header {
  width: fit-content;
  display: inline-block;
  text-align: left;
  margin: 5px 32px;
  font-size: 12px;
  color: rgb(102, 102, 102);
  min-width: 80px;
}

.p-inner {
  display: inline-block;
  margin: 12px;
  font-size: 13px;
  max-width: calc(100% - 230px);
  color: rgb(89, 89, 89);
}

.opened-details {
  text-align: center;
  color: rgb(102, 102, 102);
  font-size: 19px;
}

.due-date-red {
  color: #f85e5e;
}

#no-due-date {
  color: rgb(89, 89, 89);
}

.recurring-detail {
  text-align: center;
  font-size: 14px;
  margin-top: 9px;
  color: rgb(89, 89, 89);
}

#templatetitles {
  height: 25px;
  width: 200px;
  border: 1px solid #c4c4c4;
}

.preview-template {
  background-color: #fff;
  padding: 30px;
  margin: 70px;
  border: 1px solid #c4c4c4;
  border-radius: 3px;
}

#edit_template {
  margin: 0 10px;
  cursor: pointer;
  color: #02746e;
}

.todo-list li {
  list-style: none;
  list-style-type: none;
}
.todo-list {
  list-style: none;
  list-style-type: none;
}

body > div.ck-body-wrapper > div:nth-child(3) {
  position: relative;
  z-index: 99999;
}
</style>
<style>
.ckeditor-parent {
  padding: 25px 7%;
}
.todo-list li {
  list-style: none;
  list-style-type: none;
}
.todo-list {
  list-style: none;
  list-style-type: none;
}
</style>